import { LicenseInfo } from "@mui/x-license";

import "mapbox-gl/dist/mapbox-gl.css";

import { createRoot } from "react-dom/client";

import { initializeDatadogLogs } from "utils/datadogInit";
import { initializeSentry } from "utils/sentry";

import App from "./App";

LicenseInfo.setLicenseKey(import.meta.env.REACT_APP_MUI_LICENSE);

initializeDatadogLogs();
void initializeSentry();

// https://vitejs.dev/guide/build.html#load-error-handling
// Addressing error when new deployment happened:
// Failed to load module script: Expected a JavaScript module script but the server responded with a MIME type of "text/html". Strict MIME type checking is enforced for module scripts per HTML spec.
window.addEventListener("vite:preloadError", (event) => {
  console.error("vite:preloadError", event);
});

const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error("Root element not found");
}
const root = createRoot(rootElement);
root.render(<App />);
